import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';

export interface FiltresCommunsRapports {
  debut: string;
  fin: string;
  zoneId: number | null;
  typeEnvoi: string | null;
  granularite: 'JOUR' | 'SEMAINE' | 'MOIS' | 'TRIMESTRE' | 'SEMESTRE' | 'ANNEE';
}

@Component({
  selector: 'app-rapports',
  templateUrl: './rapports.component.html',
  styleUrls: ['./rapports.component.scss']
})
export class RapportsComponent implements OnInit {
  ongletActif: 'qualite' | 'satisfaction' | 'finance' | 'volumes' = 'qualite';

  filtres: FiltresCommunsRapports = {
    debut: '',
    fin: '',
    zoneId: null,
    typeEnvoi: null,
    granularite: 'MOIS'
  };

  roleUtilisateur = '';
  typesEnvoi: { value: string; label: string }[] = [
    { value: 'EXPRESS_URBAIN',       label: 'Express urbain' },
    { value: 'EXPRESS_INTERURBAIN',  label: 'Express interurbain' },
    { value: 'STANDARD_URBAIN',      label: 'Standard urbain' },
    { value: 'STANDARD_INTERURBAIN', label: 'Standard interurbain' }
  ];

  zones: { id: number; nom: string }[] = [];

  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    const utilisateur = this.auth.obtenirUtilisateurCourant();
    this.roleUtilisateur = utilisateur?.role || '';

    // Période par défaut : 30 derniers jours
    const maintenant = new Date();
    const ilY30Jours = new Date();
    ilY30Jours.setDate(maintenant.getDate() - 30);
    this.filtres.debut = this.toIso(ilY30Jours);
    this.filtres.fin   = this.toIso(maintenant);
  }

  private toIso(d: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:00`;
  }

  appliquerPresetPeriode(jours: number): void {
    const fin = new Date();
    const debut = new Date();
    debut.setDate(fin.getDate() - jours);
    this.filtres = { ...this.filtres, debut: this.toIso(debut), fin: this.toIso(fin) };
  }

  /** Met à jour les bornes ISO à partir des champs date HTML (sans heure). */
  surChangementDateDebut(valeur: string): void {
    if (!valeur) return;
    this.filtres = { ...this.filtres, debut: `${valeur}T00:00:00` };
  }
  surChangementDateFin(valeur: string): void {
    if (!valeur) return;
    this.filtres = { ...this.filtres, fin: `${valeur}T23:59:59` };
  }

  surChangementTypeEnvoi(valeur: string): void {
    this.filtres = { ...this.filtres, typeEnvoi: valeur || null };
  }

  surChangementGranularite(valeur: string): void {
    this.filtres = { ...this.filtres, granularite: valeur as any };
  }

  dateDebutLocale(): string {
    return this.filtres.debut?.substring(0, 10) || '';
  }
  dateFinLocale(): string {
    return this.filtres.fin?.substring(0, 10) || '';
  }

  changerOnglet(o: 'qualite' | 'satisfaction' | 'finance' | 'volumes'): void {
    this.ongletActif = o;
  }
}
